import axios from "axios"
import { id } from "date-fns/locale"
import { Host } from "./constantes"
import { clienteInfo, getDatosUsuariosLocalStorag, getUsuario } from "./DatosUsuarioLocalStorag"
import { logWithCallback } from "utilsstile.js/style"
import { comprimirImagen } from "./comprimirImagen"

// Antes mandaba x-user-id/x-user-perfil, que el navegador arma solo (sin firmar) y
// cualquiera podia falsificar. Ahora manda el JWT real que ya se guarda al loguearse.
const getHeadersWithUserContext = () => {
    return {
        'Content-Type': 'application/json',
        'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ==',
        'Authorization': `Bearer ${getUsuario()}`,
    };
}

/**Listar Suscritorea */

// QUITAR TODO ESTO 
/**Listar Roles */
export const GetRoles = async () => {
    const { data } = await axios.get("https://api.t-ickets.com/ms_login/api/v1/listar_roles", {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
        }
    })
    return data
}

/**Login de usuario */
export const Loginadmin = async (parms) => {
    const { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/auth_admin", parms, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
        }
    })
    return data
}



/**
 * Crear nuevo suscritor
 */
export const CrearSuscritor = async (parms) => {
    const { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/crear_suscriptor", parms, {
        headers: {
            'Content-Type': 'application/json',
            'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
        }
    })
    return data
}

export const ListarTikets = async () => {
    try {
        const { data } = await axios.get("https://api.t-ickets.com/pdfqr/api/v1/szchat/listar/")
        return data
    } catch (error) {
        return error
    }

}
export const ListarConcierto = async (parms) => {
    const { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/filtrar_concierto", parms, {
        headers: {
            'Content-Type': 'application/json',
            'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='

        }
    })
    return data
}
export const localidaandespacio = async (parms, id) => {
    const { data } = await axios.get("https://api.t-ickets.com/ms_login/api/v1/listar_localidades_id_espacio/" + parms + "/" + id, {
        headers: {
            'Content-Type': 'application/json',
            'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='

        }
    })
    return data
}
export const Listarlocalidadid = async (parms) => {
    const { data } = await axios.get("https://api.t-ickets.com/ms_login/api/v1/listar_localidades_id_espacio/" + parms, {
        headers: {
            'Content-Type': 'application/json',
            'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='

        }
    })
    return data
}
export const AptualizarLocalida = async (parms) => {
    //getDatosUsuariosLocalStorag
    let ids = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    let parmspro = {
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(ids),
    }
    const { data } = await axios.put("https://api.t-ickets.com/ms_login/api/v1/listar_localidades", {...parms,...parmspro}, {
        headers: {
            'Content-Type': 'application/json',
            'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='

        }
    })
    return data
}
/**50 */
export const EliminarLocalidad = async (parms) => {
    let ids = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    let parmspro = {
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(ids),
    }

    // BUG FIX: mismo error que en las demas EliminarX de este archivo -- axios.delete
    // solo acepta (url, config); el 3er arg con los headers (authorization-ticket)
    // se ignoraba, el backend respondia 401 y el catch de mas arriba lo devolvia
    // como si fuera exito. El body va en config.data.
    const { data } = await axios.delete("https://api.t-ickets.com/ms_login/api/v1/eliminar_localidad/" + parms, {
        headers: {
            'Content-Type': 'application/json',
            'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
        },
        data: parmspro
    })
    return data
}

export const FiltrarConcierto = async (parms) => {
    const { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/filtrar_concierto", { "nombreconcert": parms }, {
        headers: {
            'Content-Type': 'application/json',
            'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='

        }
    })
    return data
}
export const GuardarEvento = async (parms) => {
    let id = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    //                                      getDatosUsuariosLocalStorag
    let parmspro = {
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(id),
    }
    const { data } = await axios.post("https://api.t-ickets.com/ms_login/crearevento",{...parms,...parmspro}, {
        headers: getHeadersWithUserContext()
    })
    return data;
}

export const GuardarEventoProximo = async (parms) => {
    let id = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    let parmspro = {
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(id),
    }
    const payload = {
        ...parms,
        ...parmspro,
        LocalodadPrecios: Array.isArray(parms?.LocalodadPrecios) ? parms.LocalodadPrecios : [],
        mapaConcierto: String(parms?.mapaConcierto || "").trim(),
    }
    const { data } = await axios.post("https://api.t-ickets.com/ms_login/crearevento", payload, {
        headers: getHeadersWithUserContext()
    })
    return data;
}

// Antes esto dejaba que axios reventara la promesa en cualquier error (ej.
// 401 "sesion expirada" -- el JWT dura 1-2h). Como GetEventos() en
// Evento/index.js pide varios estados en paralelo con Promise.all, un solo
// rechazo tumbaba TODA la carga sin avisar nada -- la pagina se quedaba
// "cargando" para siempre, indistinguible de estar lenta. Ahora se atrapa
// el error y se devuelve el mismo shape {success:false,...} que ya manda el
// backend (incluye sesion_expirada:true en el 401), para que quien llama
// pueda chequearlo sin su propio try/catch y sin que Promise.all aborte las
// demas peticiones.
export const ListarEventos = async (parms) => {
    const estado = parms || "ACTIVO";
    const user = clienteInfo();
    const headers = getHeadersWithUserContext();

    console.log("[Querypanel][ListarEventos] request", {
        estado,
        userId: user?.id,
        perfil: user?.perfil,
        headers,
    });

    try {
        const { data } = await axios.get("https://api.t-ickets.com/ms_login/listareventos/" + estado + "/", {
            headers
        })

        console.log("[Querypanel][ListarEventos] response", {
            success: data?.success,
            total: Array.isArray(data?.data) ? data.data.length : 0,
            codigos: Array.isArray(data?.data) ? data.data.map((e) => e.codigoEvento) : [],
        });

        return data;
    } catch (error) {
        console.log("[Querypanel][ListarEventos] error", error?.response?.status, error?.response?.data)
        return error?.response?.data?.sesion_expirada
            ? error.response.data
            : { success: false, message: "Error al listar los eventos" }
    }
}
export const EventosActivos = async (parms) => {
    const user = clienteInfo();
    const headers = getHeadersWithUserContext();

    console.log("[Querypanel][EventosActivos] request", {
        estado: parms,
        userId: user?.id,
        perfil: user?.perfil,
        headers,
    });

    try {
        const { data } = await axios.get("https://api.t-ickets.com/ms_login/listareventos/" + parms + "/", {
            headers
        })

        console.log("[Querypanel][EventosActivos] response", {
            success: data?.success,
            total: Array.isArray(data?.data) ? data.data.length : 0,
            codigos: Array.isArray(data?.data) ? data.data.map((e) => e.codigoEvento) : [],
        });

        return data;
    } catch (error) {
        console.log("[Querypanel][EventosActivos] error", error?.response?.status, error?.response?.data)
        return error?.response?.data?.sesion_expirada
            ? error.response.data
            : { success: false, message: "Error al listar los eventos" }
    }
}
export const listarpreciolocalidad = async (parms) => {
    const { data } = await axios.get("https://api.t-ickets.com/ms_login/ListaPreciosLocalidades/" + parms, {
        headers: getHeadersWithUserContext()
    })
    return data;
}
export const EliminarEvento = async (parm) => {
    const codigoEvento = String(parm || '').trim()
    const { data } = await axios.delete("https://api.t-ickets.com/ms_login/eliminarevento/" + codigoEvento, {
        headers: getHeadersWithUserContext()
    })
    return data
}
// Guarda el orden manual de los eventos. "tipo" es 'pagina' o 'bot' -- son
// ordenes independientes (ver ModalOrdenarEventos.js). codigosEventoEnOrden
// es el arreglo de codigoEvento ya en el orden deseado (primero = arriba).
export const ActualizarOrdenEventos = async (tipo, codigosEventoEnOrden) => {
    try {
        const { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/actualizar_orden_eventos", {
            tipo, codigosEventoEnOrden
        }, {
            headers: getHeadersWithUserContext()
        })
        return data
    } catch (error) {
        return { success: false, message: "No se pudo actualizar el orden de los eventos" }
    }
}
export const EliminareventoLocalidad = async (parm, id) => {
    let ids = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    let parmspro = {
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(ids),
    }
    // BUG FIX: ver EliminarLocalidad mas arriba -- mismo error de firma de axios.delete.
    const { data } = await axios.delete("https://api.t-ickets.com/ms_login/eliminarevento/" + parm + "/" + id, {
        headers: {
            'Content-Type': 'application/json',
            'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
        },
        data: parmspro
    })
    return data
}
//

/**
 * Sube un archivo al servidor de imagenes y devuelve su URL publica.
 * @param {File} parm
 * @param {{ comprimir?: boolean, maxAncho?: number, calidad?: number }} [opciones]
 *   comprimir: true solo para imagenes que se muestran en la pagina publica
 *   (portadas, mapas, banners). Los comprobantes de pago NO se comprimen:
 *   pasan por OCR/auditoria y deben quedar tal cual se subieron.
 */
export const Obtenerlinkimagen = async (parm, opciones = {}) => {
    try {
        const archivo = opciones.comprimir ? await comprimirImagen(parm, opciones) : parm
        const fordata = new FormData();
        fordata.append('file', archivo);
        const { data } = await axios.post("https://codigomarret.online/upload/api/img", fordata,
            {
                header: {
                    'Content-Type': 'application/json',
                    'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
                }
            })
        if (!data.success) return null
        return data.url

    } catch (error) {
        return null
    }

}
export const Iamegn = (parm) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ==");

    var formdata = new FormData();
    formdata.append("file", fileInput.files);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch("https://codigomarret.online/upload/api/img", requestOptions)
        .then(response => response.text())
        .then(result => logWithCallback(result))
        .catch(error => logWithCallback( error));
}